import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationItemComponent } from './navigation-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { SharedModule } from '../../../app/shared/shared.module';

@NgModule({
  declarations: [NavigationItemComponent],
  imports: [
    CommonModule,
    MatMenuModule,

    MatIconModule,
    RouterModule,
    MatRippleModule,
    SharedModule,
  ],
  exports: [NavigationItemComponent],
})
export class NavigationItemModule {}
